// extracted by mini-css-extract-plugin
export default {"root":"PlasmicBankTransferButton_root__Tsk6x","text":"PlasmicBankTransferButton_text__O0k2w"};